import hoistNonReactStatics from 'hoist-non-react-statics';
import React from 'react';
import shallowEqual from 'shallowequal';
export default function propMapper(map) {
    return Component => {
        var _a;
        return hoistNonReactStatics((_a = class extends React.Component {
                constructor() {
                    super(...arguments);
                    this.state = {
                        sourceProps: {},
                        mappedProps: {},
                    };
                }
                static getDerivedStateFromProps(nextProps, prevState) {
                    const { sourceProps } = prevState;
                    const nextSourceProps = extractSourceProps(nextProps, map);
                    if (shallowEqual(sourceProps, nextSourceProps)) {
                        return null;
                    }
                    return {
                        sourceProps: nextSourceProps,
                        mappedProps: makeMappedProps(nextSourceProps, map),
                    };
                }
                render() {
                    const { mappedProps } = this.state;
                    return <Component {...this.props} {...mappedProps}/>;
                }
            },
            _a.displayName = `PropMapper(${Component.displayName || Component.name})`,
            _a), Component);
    };
}
function makeMappedProps(sourceProps, map) {
    return Object.keys(map).reduce((mappedProps, propName) => {
        const propNames = propName.split(',');
        const propMapper = map[propName];
        if (propNames.length === 1) {
            return {
                ...mappedProps,
                ...propMapper(sourceProps[propName]),
            };
        }
        return {
            ...mappedProps,
            ...propMapper(sourceProps),
        };
    }, {});
}
function extractSourceProps(props, map) {
    return Object.keys(map)
        .map(key => key.split(','))
        .reduce((allKeys, subKeys) => [...allKeys, ...subKeys], [])
        .reduce((result, key) => {
        result[key] = props[key];
        return result;
    }, {});
}
